// removed by extract-text-webpack-plugin
module.exports = {"inputRow":"src-components-Invest-components-___InputRow__inputRow___3r7an","label":"src-components-Invest-components-___InputRow__label___2siyL","inputBox":"src-components-Invest-components-___InputRow__inputBox___lNhwE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Invest/components/InputRow.css
// module id = 1227
// module chunks = 3